// extracted by mini-css-extract-plugin
var _1 = "_checkbox-module__container";
var _2 = "_checkbox-module__input";
var _3 = "_checkbox-module__label";
export { _1 as "container", _2 as "input", _3 as "label" }
